(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/views/about-bankid.js') >= 0) return;  svs.modules.push('/modules/player-login/views/about-bankid.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.player_login=_svs.player_login||{};
_svs.player_login.templates=_svs.player_login.templates||{};
svs.player_login.templates.about_bankid = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<section>\n  <p>\n    BankID är en elektronisk ID-handling som är jämförbar med pass, \n    körkort och andra fysiska legitimationer.\n  </p>\n\n  <b>Var beställer du BankID?</b>\n  <p>\n    Beställ BankID hos din bank.\n  </p>\n</section>\n<b>Behöver du hjälp?</b>\n<p>\n  Ring oss på <a aria-label=\"Ring Svenska spel kundservice\" href=\"tel:0770 - 11 11 11\">0770 - 11 11 11</a>\n</p>\n";
},"useData":true});
Handlebars.partials['svs-player_login-about_bankid'] = svs.player_login.templates.about_bankid;
})(svs, Handlebars);


 })(window);